import styled from "styled-components";

import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";

export const StyledRootBox = styled(Box)`
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px;
  padding: 4.5px 4px !important;
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${Colors.primary} !important;
  }
`;

export const StyledTypography = styled(Typography)<{ color: string }>`
  color: ${({ color }: { color: string }) => color};
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
`;
